module.exports = __webpack_public_path__ + "static/media/lance-coury-loop-2.3f50e998.jpg";